module.exports = __webpack_public_path__ + "static/media/download-icon.0e57f00b.svg";